import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { withToggle } from "../withToggle";

const TotalNewMembers = ({ qa }) => {
  const {
    totalNewMembersNumber,
    totalNewMembersLink,
    totalNewMembersPercentChange,
    prevTotalNewMembersNumber,
    prevTotalNewMembersLink,
    tooltip
  } = useSelector((state) => state.membershipUnits.membershipUnits.totalNewMembers.totalMembers);

  return (
    <>
      <div className="content__el">
        <DataDisplay
          label="Total New Members"
          type="number"
          value={totalNewMembersNumber}
          url={totalNewMembersLink}
          disableAnimation={qa}
          toolTipContent={tooltip}
          toolTipId="membershipUnitsTotalNewMembers"
          changeProps={{
            changeValue: totalNewMembersPercentChange,
            toolTip: "Percentage change from previous month",
            showBorder: true
          }}
        />
      </div>
      <PreviousTotalNewMembers
        title="Previous Total New Members"
        commonProps={{
          toolTipContent: `Previous ${tooltip}`,
          toolTipId: "membershipUnitsPrevTotalNewMembers"
        }}
        dataPointProps={{
          type: "number",
          value: prevTotalNewMembersNumber,
          url: prevTotalNewMembersLink,
          disableAnimation: qa
        }}
      />
    </>
  );
};

const PreviousTotalNewMembers = withToggle(DataDisplay);

export default TotalNewMembers;
